import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "../";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const postContractReopen = contractId => {
  return dispatch => {
    dispatch({ type: "POST_CONTRACT_REOPEN_LOADING" });
    api
      .contractReopenPost(contractId)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFailed());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "PostContractREopenErrorAlertTitle",
          "Virhe työsopimuksen voimaan asettamisessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "POST_CONTRACT_REOPEN_SUCCEEDED",
  payload: { contract: data },
});

const operationFailed = () => ({
  type: "POST_CONTRACT_REOPEN_FAIL",
});
